export enum VerificationCodeFailureResult {
  UserNotFoundError,
  InvalidCodeError,
}
